import { Stack, Text, Paper, Group, Badge, SimpleGrid } from '@mantine/core';
import { IconUsers, IconTarget } from '@tabler/icons-react';
import React from 'react';

interface TargetPosition {
  trLCMSPlanningTargetPositionsID: string;
  positionID: string;
  positionName: string;
}

interface PlanTargetPositionsSectionProps {
  targetPositions: TargetPosition[];
}

const PlanTargetPositionsSection: React.FC<PlanTargetPositionsSectionProps> = ({
  targetPositions
}) => {
  return (
    <Paper withBorder p={16} radius='lg'>
      <Stack gap={16}>
        <Group gap={8} align='center'>
          <IconTarget size={18} />
          <Text fw={600} size='md'>
            Target Positions ({targetPositions.length})
          </Text>
        </Group>

        {targetPositions.length > 0 ? (
          <SimpleGrid cols={1} spacing={8}>
            {targetPositions.map((position) => (
              <Group key={position.trLCMSPlanningTargetPositionsID} gap={8}>
                <IconUsers size={14} color='gray' />
                <Badge variant='light' color='violet' size='md' style={{ textTransform: 'none' }}>
                  {position.positionName}
                </Badge>
              </Group>
            ))}
          </SimpleGrid>
        ) : (
          <Group gap={8} c='dimmed'>
            <IconUsers size={14} />
            <Text size='sm'>No target positions defined</Text>
          </Group>
        )}
      </Stack>
    </Paper>
  );
};

export default PlanTargetPositionsSection;
